var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "home" } },
    [
      _c("PortalSidebar", {
        attrs: { selectedClients: _vm.selectedClients, clients: _vm.clients },
        on: { cschange: _vm.clientSelectionChanged }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-container" },
        [
          _c("PortalPageHeader"),
          _vm._v(" "),
          _c(
            "main",
            { staticClass: "main-content" },
            [
              _c("router-view", {
                attrs: { selectedClients: _vm.selectedClients }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1f1971a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1f1971a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 57/i
// module chunks = 1